import React, { useCallback, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootState } from "../store/store";
import HeaderVerified from "../components/header/HeaderVerified";
import SidebarVerified from "../components/sidebar/SidebarVerified";
import HelpAndSupport from "../components/HelpAndSupport/HelpAndSupport";
import EmailVerificationBanner from "../components/EmailVerificationBanner";
import ScrollToTop from "../components/ScrollToTop";
import AffiliatePromptHost from "../components/affiliates/AffiliatePromptHost";

export const UserLayout: React.FC = () => {
  const [showHelp, setShowHelp] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const mainRef = useRef<HTMLElement>(null);
  const userPhotoUrl = useSelector((state: RootState) => state.auth.photoUrl);

  const closeHelp = useCallback(() => setShowHelp(false), []);

  return (
    <div className="flex h-screen overflow-hidden bg-canvas">
      <ScrollToTop containerRef={mainRef} />

      <SidebarVerified mobileOpen={navOpen} onMobileOpenChange={setNavOpen} />

      <div className="flex min-w-0 flex-1 flex-col">
        <HeaderVerified
          handleClick={() => setShowHelp(true)}
          onMenuClick={() => setNavOpen(true)}
          userAvatar={userPhotoUrl || undefined}
        />
        <EmailVerificationBanner />
        <main ref={mainRef} className="scrollbar-thin min-h-0 flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>

      {/* Epic 8: Title / lender / agreement pop-ups */}
      <AffiliatePromptHost />

      {showHelp &&
        createPortal(
          <div className="fixed inset-0 z-[1050] flex justify-end">
            <div className="absolute inset-0 animate-fade-in bg-gray-950/40 backdrop-blur-[2px]" onClick={closeHelp} />
            <aside
              role="dialog"
              aria-modal="true"
              aria-label="Help and support"
              className="relative h-full w-full max-w-xl animate-rise overflow-y-auto bg-white px-6 shadow-overlay"
            >
              <HelpAndSupport onButtonClick={closeHelp} />
            </aside>
          </div>,
          document.body
        )}
    </div>
  );
};
